$( document ).ready(function() {
    $('header').removeClass('transparent-menu').addClass('pink-menu');

    // $('.shop-page-main-filters li').on('click',function(){
    //     var filter_element = $(this).data('collection-handle');
    //     filterCollection(filter_element);
    // });

    // if(window.location.hash) {
    //     var hash = window.location.hash;
    //     var parts = hash.split('#');
    //     filterCollection(parts[1]);
    // }
    // if (window.location.pathname) {
    //   const path = window.location.pathname;
    //   const handle = path.split("/")[2];
    //   filterCollection(handle);
    // }
});

// function filterCollection(filter_element) {

//     if(filter_element!='all') {
//         $('#filter_all').removeClass('active');
//         $('.shop-page-main-filters li').removeClass('active');
//         $('.shop-page-main-filters li').each(function () {
//             if($(this).data('collection-handle') == filter_element){
//                     $(this).addClass('active');
//             }
//         });
//     }else{
//         $('.shop-page-main-filters li').removeClass('active');
//         $('#filter_all').addClass('active');
//         $('.shop-page-lingerie-section').show();
//     }


//     if(filter_element!='all') {
//         $('.shop-page-lingerie-section').hide();

//         var counter_active = 0;
//         $('.shop-page-main-filters li').each(function () {
//             var active_collection_filter = $(this).data('collection-handle');
//             if ($(this).hasClass('active')) {
//                 counter_active++;
//                 $('.collection-block-' + active_collection_filter).show();
//             }
//         });

//         if (counter_active == 0) {
//             $('#filter_all').addClass('active');
//             $('.shop-page-lingerie-section').show();
//         }
//     }

// }

